import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export type CheckDuplicateOCClaimRequestParams = Record<string, unknown>;

export type CheckDuplicateOCClaimResponse = string | number;

export const checkDuplicateOCClaimAPI = (data: CheckDuplicateOCClaimRequestParams) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.OVERCHARGE_CLAIM}/CheckDuplicateClaim`,
  });
};

export const checkDuplicateOCClaim = async (
  data: CheckDuplicateOCClaimRequestParams,
): Promise<CheckDuplicateOCClaimResponse> => {
  const response: AxiosResponse<CheckDuplicateOCClaimResponse> = await checkDuplicateOCClaimAPI(data);
  return response.data;
};
